{
 "marks": [
  {
   "id": "mark.0",
   "x": 188,
   "y": 1150,
   "w": 11,
   "h": 60
  },
  {
   "id": "mark.1",
   "x": 282,
   "y": 1207,
   "w": 46,
   "h": 9
  },
  {
   "id": "mark.2",
   "x": 393,
   "y": 1207,
   "w": 45,
   "h": 9
  },
  {
   "id": "mark.3",
   "x": 504,
   "y": 1207,
   "w": 46,
   "h": 9
  },
  {
   "id": "mark.4",
   "x": 615,
   "y": 1207,
   "w": 46,
   "h": 9
  },
  {
   "id": "mark.5",
   "x": 726,
   "y": 1207,
   "w": 46,
   "h": 9
  }
 ],
 "helper": {
  "x": 201,
  "y": 1039,
  "w": 539,
  "h": 61
 },
 "resend": {
  "x": 361,
  "y": 1410,
  "w": 269,
  "h": 23
 },
 "change": {
  "x": 381,
  "y": 1495,
  "w": 180,
  "h": 24
 },
 "cellsBox": {
  "id": "cells",
  "x": 130,
  "y": 1114,
  "w": 680,
  "h": 128,
  "fill": false
 },
 "active": [
  {
   "id": "cell.0.on",
   "x": 130,
   "y": 1114,
   "w": 113,
   "h": 128
  },
  {
   "id": "cell.1.on",
   "x": 243,
   "y": 1114,
   "w": 113,
   "h": 128
  },
  {
   "id": "cell.2.on",
   "x": 357,
   "y": 1114,
   "w": 113,
   "h": 128
  },
  {
   "id": "cell.3.on",
   "x": 470,
   "y": 1114,
   "w": 113,
   "h": 128
  },
  {
   "id": "cell.4.on",
   "x": 583,
   "y": 1114,
   "w": 113,
   "h": 128
  },
  {
   "id": "cell.5.on",
   "x": 697,
   "y": 1114,
   "w": 113,
   "h": 128
  }
 ]
}